import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Summary.css';

class Summary extends React.Component {
  constructor (props) {
    super(props);
  }


  render () {
    const props = this.props;
    return (
      <div className={s.container}>
        {this.props.children}
      </div>
    );
  }
}

export default withStyles(s)(Summary);


// WEBPACK FOOTER //
// src/components/Summary/Summary.js